import {
  BUILD_RESIDENTIAL_HISTORY,
  RESIDENTIAL_HISTORY_CHANGED,
  UPDATE_RESIDENTIAL_HISTORY_START,
  UPDATE_RESIDENTIAL_HISTORY_SUCCESS,
} from './types';

export const buildResidentialHistory = (payload) => ({
  type: BUILD_RESIDENTIAL_HISTORY,
  payload: payload
})

export const residentialHistoryChanged = (payload) => ({
  type: RESIDENTIAL_HISTORY_CHANGED,
  payload: payload,
})

export const updateResidentialHistoryStart = (payload) => ({
  type: UPDATE_RESIDENTIAL_HISTORY_START,
  payload: payload,
})

export const updateResidentialHistorySuccess = (payload) => ({
  type: UPDATE_RESIDENTIAL_HISTORY_SUCCESS,
  payload: payload,
})
